import type { ComponentProps } from "react"
import {
  TRAVELTIME_ISOCHRONE_RINGS,
  type TraveltimeIsochroneRings,
} from "@/v2-ui/icon/custom/traveltimeIsochrone/traveltimeIsochrone.constants"

export type TraveltimeIsochroneProps = ComponentProps<"svg"> & {
  fill?: string
  /** One colour per ring, outer first; a ring without one takes `fill`. */
  ringColors?: readonly string[]
}

/**
 * A reach glyph: one to four nested isochrone polygons, border and
 * translucent fill in one colour (the search's, as on the map), denser
 * towards the centre, or `ringColors` one per ring, outer first.
 */
export function TraveltimeIsochrone(
  props: TraveltimeIsochroneProps & { rings: TraveltimeIsochroneRings },
) {
  const { fill = "currentColor", ringColors, rings, ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      {TRAVELTIME_ISOCHRONE_RINGS[rings].map((ring, index) => (
        <path
          key={ring.d}
          d={ring.d}
          fill={ringColors?.[index] ?? fill}
          fillOpacity={ring.fillOpacity}
          stroke={ringColors?.[index] ?? fill}
          strokeWidth={rings === 1 ? "1.75" : "1.5"}
          strokeLinejoin="round"
        />
      ))}
    </svg>
  )
}

export function TraveltimeIsochroneSingle(props: TraveltimeIsochroneProps) {
  return <TraveltimeIsochrone rings={1} {...props} />
}
export function TraveltimeIsochroneDouble(props: TraveltimeIsochroneProps) {
  return <TraveltimeIsochrone rings={2} {...props} />
}
export function TraveltimeIsochroneTriple(props: TraveltimeIsochroneProps) {
  return <TraveltimeIsochrone rings={3} {...props} />
}
export function TraveltimeIsochroneQuadruple(props: TraveltimeIsochroneProps) {
  return <TraveltimeIsochrone rings={4} {...props} />
}
